import React from "react";

export const EmptyList = () => {
  return <div>No jobs found.</div>;
};
EmptyList.displayName = "EmptyList";
